// page/System/router.js
// System菜单下管理的路由文件
export default [{
		path: '/RequestItemList',
		component: () => import('./RequestItemList.vue'),
		name: 'RequestItemList',
		meta: {
			title: 'Sidebar.report[0]'
		}
	},
	{
		path: '/PurchaseItemList',
		component: () => import('./PurchaseItemList.vue'),
		name: 'PurchaseItemList',
		meta: {
			title: 'Sidebar.report[1]'
		}
	},
	{
		path: '/PurchaseItemStockInList',
		component: () => import('./PurchaseItemStockInList.vue'),
		name: 'PurchaseItemStockInList',
		meta: {
			title: 'Sidebar.report[2]'
		}
	},
	{
		path: '/ItemPriceHistory',
		component: () => import('./ItemPriceHistory.vue'),
		name: 'ItemPriceHistory',
		meta: {
			title: 'Sidebar.report[3]'
		}
	},
	{
		path: '/DataMaintainList',
		component: () => import('./DataMaintainList.vue'),
		name: 'DataMaintainList',
		meta: {
			title: 'Sidebar.report[4]'
		}
	},
	{
		path: '/DepartBudgetBalance',
		component: () => import('./DepartBudgetBalance.vue'),
		name: 'DepartBudgetBalance',
		meta: {
			title: 'Sidebar.report[5]'
		}
	},
	{
		path: '/PaymentList',
		component: () => import('./PaymentList.vue'),
		name: 'PaymentList',
		meta: {
			title: 'Sidebar.report[6]'
		}
	},
	{
		path: '/OutstandingPaymentlist',
		component: () => import('./OutstandingPaymentlist.vue'),
		name: 'OutstandingPaymentlist',
		meta: {
			title: 'Sidebar.report[7]'
		}
	},
	{
		path: '/PaymentSummary',
		component: () => import('./PaymentSummary.vue'),
		name: 'PaymentSummary',
		meta: {
			title: 'Sidebar.report[8]'
		}
	},
	{
		path: '/Purchasingpaymentreport',
		component: () => import('./Purchasingpaymentreport.vue'),
		name: 'Purchasingpaymentreport',
		meta: {
			title: 'Sidebar.report[9]'
		}
	},
	{
		path: '/Summarybydept',
		component: () => import('./Summarybydept.vue'),
		name: 'Summarybydept',
		meta: {
			title: 'Sidebar.report[10]'
		}
	},
	{
		path: '/POOfRequestDetail',
		component: () => import('./POOfRequestDetail.vue'),
		name: 'POOfRequestDetail',
		meta: {
			title: 'Sidebar.report[11]'
		}
	},
	{
		path: '/ProjectManagementReport',
		component: () => import('./ProjectManagement.vue'),
		name: 'ProjectManagementReport',
		meta: {
			title: 'Sidebar.report[12]'
		}
	}
];


// WEBPACK FOOTER //
// ./src/components/page/Report/router.js